import { render, staticRenderFns } from "./Forgot-Password-Confirm.vue?vue&type=template&id=62aa57dc&scoped=true"
import script from "./Forgot-Password-Confirm.vue?vue&type=script&lang=js"
export * from "./Forgot-Password-Confirm.vue?vue&type=script&lang=js"
import style0 from "./Forgot-Password-Confirm.vue?vue&type=style&index=0&id=62aa57dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aa57dc",
  null
  
)

export default component.exports